<template>
  <div v-if="$hasFonction(user, 'Activer démarcheurs')">
    <div :hidden="hiddenLoader" id="loader" class="text-center">
      <b-icon-circle-fill animation="throb" font-scale="4"></b-icon-circle-fill>
    </div>

    <div>
      <div v-show="add">
        <app-collapse>
          <app-collapse-item
            isVisible
            title="Ajouter un démarcheur"
            v-if="$hasFonction(user, 'Ajouter démarcheurs')"
          >
            <!-- form start -->
            <validation-observer ref="addForm">
              <b-form class="col mt-2" @submit.prevent>
                <b-row>
                  <b-form-group class="col mr-2">
                    <validation-provider
                      #default="{ errors }"
                      name="name"
                      rules="required"
                    >
                      <label for="name">Nom et Prénom</label>
                      <b-form-input
                        id="name"
                        v-model="defaultForm.name"
                        :state="errors.length > 0 ? false : null"
                        type="text"
                        placeholder="Nom et Prénom"
                        @click="resetInputName"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                      <small class="text-danger">{{ errorsName }}</small>
                    </validation-provider>
                  </b-form-group>

                  <b-form-group class="col">
                    <validation-provider
                      #default="{ errors }"
                      name="phone"
                      rules="required"
                    >
                      <label for="phone">Téléphone</label>
                      <b-form-input
                        id="phone"
                        v-model="defaultForm.phone"
                        :state="errors.length > 0 ? false : null"
                        type="tel"
                        placeholder="Téléphone"
                        @click="resetInputPhone"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                      <small class="text-danger">{{ errorsPhone }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-row>
                <!-- submit button start -->
                <div class="mt-2">
                  <b-button
                    class="mr-2"
                    variant="outline-secondary"
                    type="reset"
                    @click="resetInput"
                  >
                    Annuler
                  </b-button>

                  <b-button
                    v-if="etatButton"
                    variant="primary"
                    type="submit"
                    :disabled="isOperating"
                    @click.prevent="addDemarcheurs"
                  >
                    Enregistrer
                  </b-button>

                  <b-button v-else variant="primary">
                    <b-icon-arrow-clockwise
                      animation="spin"
                      font-scale="1"
                    ></b-icon-arrow-clockwise>
                    En cours
                  </b-button>
                </div>
                <!-- submit button end -->
              </b-form>
            </validation-observer>
            <!-- form end -->
          </app-collapse-item>
        </app-collapse>
      </div>

      <div :hidden="hidden">
        <app-collapse>
          <app-collapse-item
            ref="collapse"
            title="Ajouter un démarcheur"
            v-if="$hasFonction(user, 'Ajouter démarcheurs')"
          >
            <!-- form start -->
            <validation-observer ref="addForm">
              <b-form class="col mt-2" @submit.prevent>
                <b-row>
                  <b-form-group class="col mr-2">
                    <validation-provider
                      #default="{ errors }"
                      name="name"
                      rules="required"
                    >
                      <label for="name">Nom et Prénom</label>
                      <b-form-input
                        id="name"
                        v-model="defaultForm.name"
                        :state="errors.length > 0 ? false : null"
                        type="text"
                        placeholder="Nom et Prénom"
                        @click="resetInputName"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                      <small class="text-danger">{{ errorsName }}</small>
                    </validation-provider>
                  </b-form-group>

                  <b-form-group class="col">
                    <validation-provider
                      #default="{ errors }"
                      name="phone"
                      rules="required"
                    >
                      <label for="phone">Téléphone</label>
                      <b-form-input
                        id="phone"
                        v-model="defaultForm.phone"
                        :state="errors.length > 0 ? false : null"
                        type="tel"
                        placeholder="Téléphone"
                        @click="resetInputPhone"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                      <small class="text-danger">{{ errorsPhone }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-row>
                <!-- submit button start -->
                <div class="mt-2">
                  <b-button
                    class="mr-2"
                    variant="outline-secondary"
                    type="reset"
                    @click="resetInput"
                  >
                    Annuler
                  </b-button>

                  <b-button
                    v-if="etatButton"
                    variant="primary"
                    type="submit"
                    :disabled="isOperating"
                    @click.prevent="addDemarcheurs"
                  >
                    Enregistrer
                  </b-button>

                  <b-button v-else variant="primary">
                    <b-icon-arrow-clockwise
                      animation="spin"
                      font-scale="1"
                    ></b-icon-arrow-clockwise>
                    En cours
                  </b-button>
                </div>
                <!-- submit button end -->
              </b-form>
            </validation-observer>
            <!-- form end -->
          </app-collapse-item>
        </app-collapse>

        <b-card no-body title="" class="mt-1">
          <div class="container-search-btn flex-stack my-2 mx-2">
            <!-- search start -->
            <div class="container-search mr-1">
              <b-form-input
                id="filter-input"
                v-model="filter"
                type="search"
                placeholder="Recherche"
              >
              </b-form-input>
            </div>
            <!-- search end -->

            <!-- bouton export start -->
			<div>
				<b-button
					v-if="$hasFonction(user, 'Exporter démarcheurs')"
					variant="outline-primary"
					size="sm"
					@click="ExportFomatExcel"
				>
					<b-icon-file-earmark-arrow-down-fill></b-icon-file-earmark-arrow-down-fill>
					Exporter
				</b-button>

        <b-button
					v-if="$hasFonction(user, 'Exporter démarcheurs')"
					variant="outline-primary"
					size="sm"
          class="ml-sm-2 mt-2 mt-sm-0"
					@click="ExportAllToFomatExcel"
				>
					<b-icon-file-earmark-arrow-down-fill></b-icon-file-earmark-arrow-down-fill>
					Tout Exporter
				</b-button>
			</div>
            <!-- bouton export end -->
          </div>

          <!-- table start -->
          <b-table
            v-model="ExcelDemarcheurs"
            id="my-table"
            responsive="sm"
            :fields="headers"
            :items="demarcheurs"
            :per-page="perPage"
            :current-page="currentPage"
            :filter="filter"
            @filtered="onFiltered"
            show-empty
            class="border-bottom"
          >
            <!-- iconAction start -->
            <template #cell(actions)="data">
              <div class="row">
                <div>
                  <b-button
                    :id="'button-1' + data.item.id"
                    v-if="$hasFonction(user, 'Modifier démarcheurs')"
                    size="sm"
                    variant="flat-primary"
                    class="btn-icon"
                    @click="editDemarcheur(data.item)"
                  >
                    <feather-icon icon="Edit2Icon" />
                  </b-button>
                  <!-- <b-tooltip
                    :target="'button-1' + data.item.id"
                    title="Editer"
                    variant="dark"
                  ></b-tooltip> -->
                </div>
                <div>
                  <b-button
                    :id="'button-2' + data.item.id"
                    v-if="$hasFonction(user, 'Supprimer démarcheurs')"
                    size="sm"
                    variant="flat-danger"
                    @click="deleteDemarcheur(data.item)"
                  >
                    <feather-icon icon="TrashIcon" />
                  </b-button>
                  <!-- <b-tooltip
                    :target="'button-2' + data.item.id"
                    title="Supprimer"
                    variant="dark"
                  ></b-tooltip> -->
                </div>
              </div>
            </template>
            <!-- iconAction end -->

            <template #empty>
              <div class="text-center">
                <span class="text-nowrap">Aucune donnée existante</span>
              </div>
            </template>
            <template #emptyfiltered>
              <div class="text-center">
                <span class="text-nowrap"
                  >L'élément recherché n'est pas dans la liste</span
                >
              </div>
            </template>
          </b-table>
          <!-- table end -->

          <div class="my-2 mx-2 row">
            <!-- per-page end -->
            <div class="col">
              <b-form-select
                id="per-page-select"
                v-model="perPage"
                :options="pageOptions"
                style="width: 70px"
              ></b-form-select>
              <span class="text-nowrap ml-1" v-if="allRows != 0"> 1 - <span v-if="perPage >= allRows">{{ allRows }}</span> 
	                  <span v-if="perPage < allRows"> {{perPage}} </span> sur {{ allRows }}
                    </span>
              <span class="text-nowrap ml-1" v-if="allRows == 0"> 0 éléments</span>
            </div>
            <!-- per-page end -->

            <!-- pagination start -->
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              aria-controls="my-table"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
            <!-- pagination end -->
          </div>
        </b-card>

        <!-- modal edit start  -->
        <b-modal
          id="modal-edit"
          v-model="modalEdit"
          :ok-disabled="isOperating"
          title="Modifier les informations"
          @hidden="resetModal"
          hide-footer
          centered
        >
          <!-- form start -->
          <b-form ref="editForm" @submit.stop.prevent="handleSubmit">
            <b-form-group>
              <validation-provider
                #default="{ errors }"
                name="name"
                rules="required"
              >
                <label for="name">Nom et Prénom</label>
                <b-form-input
                  id="name"
                  placeholder="Nom et Prénom"
                  type="text"
                  v-model="editedForm.name"
                  @click="resetInputNameModal"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
                <small class="text-danger">{{
                  errors[0] ? "" : errorsNameModal
                }}</small>
              </validation-provider>
            </b-form-group>

            <b-form-group>
              <validation-provider
                #default="{ errors }"
                name="phone"
                rules="required"
              >
                <label for="phone">Téléphone</label>
                <b-form-input
                  id="phone"
                  type="tel"
                  v-model="editedForm.phone"
                  placeholder="Téléphone"
                  @click="resetInputPhoneModal"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
                <small class="text-danger">{{
                  errors[0] ? "" : errorsPhoneModal
                }}</small>
              </validation-provider>
            </b-form-group>

            <b-form-group class="mb-0">
              <b-button
                variant="outline-secondary"
                type="reset"
                class="mt-2 mr-1"
                @click="modalEdit = false"
              >
                Annuler
              </b-button>

              <b-button
                v-if="etatButtonEdit"
                variant="primary"
                class="mt-2"
                :disabled="isOperating"
                @click="handleOk"
              >
                Enregistrer
              </b-button>

              <b-button v-else variant="primary" class="mt-2">
                <b-icon-arrow-clockwise
                  animation="spin"
                  font-scale="1"
                ></b-icon-arrow-clockwise>
                En cours
              </b-button>
            </b-form-group>
          </b-form>
          <!-- form end -->
        </b-modal>
        <!-- modal edit end-->
      </div>

      <div :hidden="hiddenEmpty" class="text-center">
        <empty-list></empty-list>
        <b-button variant="primary" size="sm" @click="etatAdd">
          <b-icon-plus></b-icon-plus>
          AJOUTER
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import EmptyList from "@core/components/empty-list/EmptyList.vue";
import BCardCode from "@core/components/b-card-code/BCardCode.vue";
import { json2excel, excel2json } from "js2excel";
import downloadExcel from "json2excel-js";
import AppCollapse from "@core/components/app-collapse/AppCollapse.vue";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, integer, alpha, alphaDash } from "@validations";
import {
  BCard,
  BTable,
  BCardText,
  BAlert,
  BModal,
  BPagination,
  BButton,
  BIconPencilFill,
  BIconTrashFill,
  BIconPlus,
  BIconArrowClockwise,
  BIconCircleFill,
  BIconFileEarmarkArrowDownFill,
  BForm,
  BRow,
  BCol,
  BTooltip,
  BFormGroup,
  BFormSelect,
  BFormInput,
  BCollapse,
  BFormInvalidFeedback,
} from "bootstrap-vue";

export default {
  components: {
    BCard,
    BTable,
    BModal,
    BCardText,
    BAlert,
    BCardCode,
    BPagination,
    BButton,
    EmptyList,
    BIconPlus,
    BIconPencilFill,
    BIconTrashFill,
    BIconArrowClockwise,
    BIconCircleFill,
    BIconFileEarmarkArrowDownFill,
    BForm,
    BRow,
    BCol,
    BTooltip,
    BFormGroup,
    BFormSelect,
    BFormInput,
    BCollapse,
    BFormInvalidFeedback,
    AppCollapse,
    AppCollapseItem,
    ValidationProvider,
    ValidationObserver,
    json2excel,
    excel2json,
    downloadExcel,
  },
  data() {
    return {
      etatButton: true,
      etatButtonEdit: true,
      add: false,
      hidden: true,
      hiddenEmpty: true,
      hiddenLoader: false,
      isOperating: false,
      required,
      integer,
      alpha,
      alphaDash,
      nameState: null,
      errorsName: null,
      errorsPhone: null,
      errorsNameModal: null,
      errorsPhoneModal: null,
      modalEdit: false,
      perPage: 5,
      currentPage: 1,
      allRows: 0,
      filter: null,
      pageOptions: [],
      headers: [
        // {
        // 	key: '#',
        // 	label: '',
        // 	sortable: false,
        // },
        {
          key: "name",
          label: "Nom & Prénom",
          sortable: true,
        },
        {
          key: "phone",
          label: "Téléphone",
          sortable: true,
        },
        {
          key: "actions",
          label: "Actions",
          sortable: false,
          class: "w-25",
        },
      ],
      demarcheurs: [],
      ExcelDemarcheurs: null,
      editedForm: {
        name: "",
        phone: "",
      },
      defaultForm: {
        name: "",
        phone: "",
      },
    };
  },
  mounted() {},
  computed: {
    ...mapState({
      user: (state) => state.user.auth,
    }),
    totalRows() {
      // Set the initial number of items
      this.pageOptions = [5, 10, 25, 50, 100, { value: this.demarcheurs.length, text: "Tout" } ]
      return this.allRows;
    },
  },
  created() {
    this.getDemarcheurs();
  },
  methods: {
    etatAdd() {
      this.add = true;
      this.hiddenEmpty = true;
    },
    resetForm() {
      this.defaultForm.name = "";
      this.defaultForm.phone = "";
    },
    resetModal() {
      this.editedForm.name = "";
      this.editedForm.phone = "";
      this.nameState = null;
      this.resetInputModal();
    },
    resetInput() {
      this.resetInputName();
      this.resetInputPhone();
    },
    resetInputName() {
      if (this.errorsName) {
        this.errorsName = null;
      }
    },
    resetInputPhone() {
      if (this.errorsPhone) {
        this.errorsPhone = null;
      }
    },
    resetInputModal() {
      this.resetInputNameModal();
      this.resetInputPhoneModal();
    },
    resetInputNameModal() {
      if (this.errorsNameModal) {
        this.errorsNameModal = null;
      }
    },
    resetInputPhoneModal() {
      if (this.errorsPhoneModal) {
        this.errorsPhoneModal = null;
      }
    },
    showToast(titre, type) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: titre,
          icon: type === "success" ? "CheckSquareIcon" : "AlertCircleIcon",
          variant: type,
        },
      });
    },

    onFiltered(filteredItems) {
        this.allRows =  filteredItems.length 
        this.currentPage = 1
      },

    getDemarcheurs() {
      this.$http
        .get("/demarcheurs")
        .then((res) => {
          if (res.status) {
            this.hiddenLoader = true;
          }

          this.demarcheurs = res.data.data.reverse();

          if (this.demarcheurs.length) {
            this.hidden = false;
            this.hiddenEmpty = true;
          } else {
            this.hidden = true;
            this.hiddenEmpty = false;
          }

          this.allRows = this.demarcheurs.length

        })
        .catch((e) => {
          console.log("erreur de récupération:" + e.response.data.message);
        });
    },
    addDemarcheurs() {
      this.$refs.addForm.validate().then((success) => {
        if (success) {
          this.etatButton = false;
          this.$http
            .post("/demarcheurs", this.defaultForm)
            .then((result) => {
              if (result.data.success) {
                this.etatButton = true;
                this.resetInput();
                this.defaultForm = JSON.parse(
                  JSON.stringify({ type: Object, default: () => {} })
                );
                this.add = false;
                this.hidden = false;
                this.showToast("Démarcheur ajouté avec succès", "success");
                this.$refs.addForm.reset();
                if (this.demarcheurs.length) {
                  this.$refs.collapse.updateVisible(false);
                }
                this.getDemarcheurs();
                // this.resetForm()
              } else {
                this.etatButton = true;
                this.showToast(result.data.message, "danger");
              }
            })
            .catch((e) => {
              this.etatButton = true;
              var err = e.response.data.errors;
              // this.isOperating = false;

              if (err.name) {
                this.errorsName = err.name[0];
              }

              if (err.phone) {
                this.errorsPhone = err.phone[0];
              }
            });
        }
      });
    },
    checkFormValidity() {
      const valid = this.$refs.editForm.checkValidity();
      this.nameState = valid;
      return valid;
    },
    handleSubmit() {
      // this.$refs.editForm.validate().then((success) => {
      // 	if (success) {
      if (!this.checkFormValidity()) {
        return;
      }
      this.etatButtonEdit = false;
      this.$http
        .put("/demarcheurs/" + this.editedForm.id, this.editedForm)
        .then((result) => {
          // 	this.isOperating = false;
          if (result.data.success) {
            this.etatButtonEdit = true;
            this.resetInputModal();
            this.editedForm = JSON.parse(
              JSON.stringify({ type: Object, default: () => {} })
            );
            this.modalEdit = false;
            this.showToast("Démarcheur modifié avec succès", "success");
            this.$refs.addForm.reset();
            this.getDemarcheurs();
          } else {
            this.etatButtonEdit = true;
            this.showToast(result.data.message, "danger");
          }
        })
        .catch((e) => {
          this.etatButtonEdit = true;
          console.log("erreur modification:" + e);
          // this.isOperating = false;
          var err = e.response.data.errors;
          // this.isOperating = false;

          if (err.name) {
            this.errorsNameModal = err.name[0];
          }

          if (err.phone) {
            this.errorsPhoneModal = err.phone[0];
          }
        });
      // 	}
      // });

      // Hide the modal manually
      this.$nextTick(() => {
        this.$bvModal.hide("modal-prevent-closing");
      });
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();

      // Trigger submit handler
      this.handleSubmit();
    },
    editDemarcheur(item) {
      this.editedForm = Object.assign({}, item);
      this.modalEdit = true;
    },
    deleteDemarcheur(item) {
      // Message de suppression
      this.$bvModal
        .msgBoxConfirm(
          "Voulez-vous vraiment supprimer cet enregistrement de la liste des démarcheurs ?",
          {
            title: "Supprimer un démarcheur",
            okVariant: "danger",
            cancelVariant: "outline-secondary",
            okTitle: "Confirmer",
            cancelTitle: "Annuler",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then((value) => {
          if (value === true) {
            this.$http
              .delete("/demarcheurs/" + item.id)
              .then((result) => {
                if (result.data.success) {
                  this.showToast("Supression effectuée avec succès", "success");
                  this.getDemarcheurs();
                } else {
                  this.showToast(result.data.message, "danger");
                }
              })
              .catch((err) => {
                this.showToast(err.response, "error");
              });
          }
        });
    },
    ExportFomatExcel() {
      let { json2excel, excel2json } = require("js2excel");
      // let headers = this.headers
      let data = [];
      let obj = {};

      this.ExcelDemarcheurs.forEach((element) => {
        obj = {
          "NOM & PRÉNOM": element.name,
          TÉLÉPHONE: element.phone,
        };

        data.push(obj);
      });

      if (data) {
        try {
          json2excel({
            // headers,
            data,
            name: "FlashCar - Liste Démarcheurs",
            formateDate: "yyyy/mm/dd",
          });
        } catch (e) {
          console.log(e);
        }
      }
    },

    ExportAllToFomatExcel() {
      let { json2excel, excel2json } = require("js2excel");
      // let headers = this.headers
      let data = [];
      let obj = {};

      this.demarcheurs.forEach((element) => {
        obj = {
          "NOM & PRÉNOM": element.name,
          TÉLÉPHONE: element.phone,
        };

        data.push(obj);
      });

      if (data) {
        try {
          json2excel({
            // headers,
            data,
            name: "FlashCar - Liste Démarcheurs",
            formateDate: "yyyy/mm/dd",
          });
        } catch (e) {
          console.log(e);
        }
      }
    },

  },
};
</script>

<style>
	#loader {
		position: absolute;
		width: 100%;
		height: 100%;
		background-color: #f8f8f8;
		padding-top: 15%;
		z-index: 1000;
	}

	.container-search-btn {
		display: flex !important;
	}

	.flex-stack {
		justify-content: space-between;
		align-items: center;
	}
	
	@media screen and (max-width: 435px) {
		.container-search-btn {
			display: flex !important;
		}

		.container-search {
			width: 50%;
		}
	}

	@media screen and (max-width: 327px) {
		.container-search {
			width: 100%;
			margin-bottom: 10px;
		}

		.container-search-btn {
			display: block !important;
		}
	}
</style>